import React from "react";

const TabsComponent = ({ tabs, selectedTab, onSelectTab }) => {
  const totalCount = tabs.reduce((sum, tab) => sum + tab.count, 0);

  return (
    <div className="w-full h-[34px] flex items-center space-x-4">
      {tabs.map((tab, index) => {
        const isAllTab = tab.label.toLowerCase() === "all";
        const tabCount = isAllTab && selectedTab === index ? totalCount : tab.count;

        return (
        <div
          key={index}
          onClick={() => onSelectTab(index)}
          className={`flex items-center gap-2 py-2 px-3 rounded-full [font-family:'Inter-Regular',Helvetica] shadow-md tracking-[0] text-lg font-normal whitespace-nowrap leading-5 cursor-pointer ${
            selectedTab === index
              ? "text-[#FFF] bg-[#50869A] "
              : "text-[#1d2951] bg-white"
          }`}
          style={{ fontSize: "15px" }}
        >
          {tab.label}
          <span className="bg-[#e17954] text-white rounded-full w-5 h-5 text-center font-bold text-[9px] flex items-center justify-center">
            {tabCount}
          </span>
          </div>
        );
      })}
    </div>
  );
};

export default TabsComponent;